import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';
import { GetAntiForgeryResponse } from './types';

export const getAntiForgery = async (lang = 'en') => {
	const search = window.location.search;
	const queryParams = [`culture=${lang}`];
	if (search) queryParams.push(search.slice(1));

	return fetch(`${PUBLIC_IDM_API_URL_ENV}/errors/anti-forgery?${queryParams.join('&')}`, {
		method: 'GET',
		credentials: 'include',
	})
	.then((res) => {
		if (res.ok) return res.json() as Promise<GetAntiForgeryResponse>;
	})
	.catch((error) => {
		console.error('Anti Forgery request error: ', error);
		throw error;
	});
};
